import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues, LanguageSkillEntry } from 'utils/cv-form-db';
import { StepProgressIndicator } from '../../components/StepProgressIndicator';
import { LanguageSkillsDetailsList } from './LanguageSkillsDetailsList';
import { LanguageSkillsForm } from './LanguageSkillsForm';

interface LanguageSkillsContentProps {
  isFormOpen: boolean;
  isEditing: boolean;
  editingItem: LanguageSkillEntry | null;
  onAdd: (item: LanguageSkillEntry) => void;
  onEdit: (item: LanguageSkillEntry) => void;
  onCancel: () => void;
  onAddClick: () => void;
  onEditClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

export const LanguageSkillsContent = ({
  isFormOpen,
  isEditing,
  editingItem,
  onAdd,
  onEdit,
  onCancel,
  onAddClick,
  onEditClick,
  onDeleteClick
}: LanguageSkillsContentProps) => {
  const { values } = useFormikContext<CVBuilderFormValues>();

  return (
    <Box data-testid="language-skills-content">
      <ContentCard
        title={getTrans('cvBuilderPage.languageSkills.title')}
        titleVariant="h4"
      >
        <Box sx={{ mb: 2 }}>
          <StepProgressIndicator
            showPercentage={true}
            size="medium"
            variant="compact"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          {getTrans('cvBuilderPage.languageSkills.instruction')}
        </Box>
      </ContentCard>

      {isFormOpen ? (
        <LanguageSkillsForm
          mode={isEditing ? 'edit' : 'add'}
          initialValues={editingItem || undefined}
          onSubmit={isEditing ? onEdit : onAdd}
          onCancel={onCancel}
        />
      ) : (
        <LanguageSkillsDetailsList
          values={values}
          onAddClick={onAddClick}
          onEditLanguageSkill={onEditClick}
          onDeleteLanguageSkill={onDeleteClick}
        />
      )}
    </Box>
  );
};
